export default __webpack_public_path__ + "static/media/Chifoumi.8a4dbb49.jpg";